import "core-js/modules/es6.regexp.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "search-item"
  }, [_c('form', {
    staticClass: "d-flex search-form",
    class: {
      searching: _vm.search !== '',
      shake: _vm.search === '' && _vm.searchError
    },
    attrs: {
      "action": _vm.formAction,
      "method": "get",
      "role": "search"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit();
      }
    }
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "search"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('search'))
    }
  }), _vm._v(" "), _c('input', {
    ref: "search",
    staticClass: "search-input",
    class: {
      'input-active': _vm.search
    },
    attrs: {
      "placeholder": _vm.$t('search'),
      "aria-label": _vm.$t('search'),
      "name": "searchQuery",
      "disabled": _vm.searchInputLoading,
      "type": "search",
      "autocomplete": "off",
      "data-el": "search-bar__input"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": function input($event) {
        return _vm.handleInput($event);
      },
      "click": _vm.openSearch,
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.resetForm.apply(null, arguments);
      },
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) return null;
        $event.preventDefault();
        return _vm.handleArrowUp.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) return null;
        $event.preventDefault();
        return _vm.handleArrowDown.apply(null, arguments);
      }]
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-link p-0 search-btn search-btn-close",
    class: {
      'input-active': _vm.search
    },
    attrs: {
      "type": "button",
      "name": "searchClose"
    },
    on: {
      "click": function click($event) {
        return _vm.resetForm();
      }
    }
  }, [_vm.search ? _c('mdm-icon', {
    staticClass: "fill-white close-search",
    attrs: {
      "width": "40",
      "height": "40",
      "name": "cross",
      "aria-label": "search"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn-link m-0 p-0 search-btn",
    attrs: {
      "type": "submit",
      "disabled": _vm.searchInputLoading,
      "name": "searchSubmit"
    }
  }, [_c('mdm-icon', {
    staticClass: "fill-kraft",
    attrs: {
      "width": "26",
      "height": "26",
      "name": "loupe",
      "aria-label": "search"
    }
  })], 1)]), _vm._v(" "), _c('SearchDataProvider', {
    attrs: {
      "search": _vm.sanitizedSearch
    },
    on: {
      "results-received": _vm.saveABTests
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var keyword = _ref.keyword,
          data = _ref.data,
          loading = _ref.loading;
        return [_vm.searchResults && !loading && (data.totalProducts || data.suggestions) ? _c('SearchResultsModal', {
          ref: "searchResults",
          class: {
            'search-results-sticked': _vm.hasStickedFilters,
            'only-suggestion': data.totalProducts === 0 && data.suggestions.length > 0
          },
          attrs: {
            "results": data,
            "keywords": keyword
          },
          on: {
            "submit": _vm.goToSearch,
            "view-suggested-item": _vm.handleLeaveViewSuggestion,
            "leave-list-navigation": function leaveListNavigation($event) {
              return _vm.focus();
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };